module.exports = __webpack_public_path__ + "img/KM.937d9464.png";